export default __webpack_public_path__ + "static/media/image-13.1cc18d5a.jpg";